package dev.moetz.sslcertificatetool.http

import kotlinx.serialization.Serializable

@Serializable
data class SubmitDomainRequestBody(
    val domain: String,
    val port: Int?,
)
